(function(){
  if (window.AppletonBrooksProjectPalette) return;

  var KEY = 'appletonBrooksProjectPalette';

  function read(){
    try {
      var value = JSON.parse(localStorage.getItem(KEY) || '[]');
      return Array.isArray(value) ? value : [];
    } catch (e) { return []; }
  }

  function cleanItem(item){
    item = item || {};
    return {
      id: item.id != null ? String(item.id) : '',
      title: item.title || item.colour || 'Tile',
      handle: item.handle || '',
      range: item.range || '',
      colour: item.colour || '',
      url: item.url || '',
      image: item.image || '',
      variant: item.variant || '',
      genericColour: item.genericColour || '',
      effect: item.effect || '',
      finish: item.finish || ''
    };
  }

  function contains(items, item){
    var id = String((item || {}).id || '');
    return !!id && items.some(function(existing){ return String(existing.id) === id; });
  }

  function modeActive(){
    try { return new URL(window.location.href).searchParams.get('palette') === '1'; }
    catch (e) { return false; }
  }

  function notify(items){
    try { window.dispatchEvent(new CustomEvent('ab:palette:update', { detail: { items: items } })); } catch (e) {}
  }

  function refreshContext(items){
    var bar = document.querySelector('.ab-palette-context');
    if (!bar) return;
    var count = bar.querySelector('[data-ab-palette-context-count]');
    if (count) count.textContent = String(items.length);
  }

  function refresh(){
    var items = read();
    document.querySelectorAll('[data-ab-palette-count]').forEach(function(node){
      var value = String(items.length);
      if (node.textContent !== value) node.textContent = value;
    });
    document.querySelectorAll('.ab-palette-save').forEach(function(button){
      var item = button._abPaletteItem || cleanItem({ id: button.getAttribute('data-ab-palette-id') || '' });
      var saved = contains(items, item);
      var label = saved ? 'Added to this palette' : 'Add to this palette';
      if (button.textContent !== label) button.textContent = label;
      button.classList.toggle('is-saved', saved);
      button.setAttribute('aria-pressed', saved ? 'true' : 'false');
    });
    refreshContext(items);
  }

  function write(items){
    try { localStorage.setItem(KEY, JSON.stringify(items)); } catch (e) {}
    refresh();
    notify(items);
    return items;
  }

  function add(item){
    item = cleanItem(item);
    if (!item.id) return read();
    var items = read();
    if (!contains(items, item)) items.push(item);
    return write(items);
  }

  function remove(id){
    id = String(id || '');
    return write(read().filter(function(item){ return String(item.id) !== id; }));
  }

  function toggle(item){
    item = cleanItem(item);
    return contains(read(), item) ? remove(item.id) : add(item);
  }

  function parseJson(node){
    if (!node) return null;
    try { return cleanItem(JSON.parse(node.textContent || '{}')); } catch (e) { return null; }
  }

  function itemFromSampleButton(button){
    if (!button) return null;
    return cleanItem({
      id: button.dataset.sampleId || button.dataset.id || '',
      title: button.dataset.sampleTitle || ((button.dataset.sampleRange || button.dataset.range || '') + ' — ' + (button.dataset.sampleColour || button.dataset.colour || '')).replace(/^\s*—\s*|\s*—\s*$/g,''),
      handle: button.dataset.sampleHandle || button.dataset.handle || '',
      range: button.dataset.sampleRange || button.dataset.range || '',
      colour: button.dataset.sampleColour || button.dataset.colour || '',
      url: button.dataset.sampleUrl || button.dataset.url || '',
      image: button.dataset.sampleImage || button.dataset.image || '',
      variant: button.dataset.sampleVariant || button.dataset.variant || 'Colour sample'
    });
  }

  function addSaveButton(container, item){
    if (!modeActive() || !container || !item || !item.id || container.querySelector('.ab-palette-save')) return;
    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'ab-palette-save';
    button.setAttribute('aria-pressed', 'false');
    button.setAttribute('data-ab-palette-id', item.id);
    button._abPaletteItem = cleanItem(item);
    button.textContent = 'Add to this palette';
    button.addEventListener('click', function(){ toggle(button._abPaletteItem); });
    container.appendChild(button);
  }

  function removeSaveButtons(){
    document.querySelectorAll('.ab-palette-save').forEach(function(button){ button.remove(); });
  }

  function injectSaveButtons(){
    if (!modeActive()) {
      removeSaveButtons();
      return;
    }

    var productData = parseJson(document.getElementById('ab-dp-sample-data'));
    if (productData) addSaveButton(document.querySelector('.ab-dp__actions'), productData);

    document.querySelectorAll('.ab-dp__related-item').forEach(function(card){
      addSaveButton(card, parseJson(card.querySelector('.ab-dp__related-sample-data')));
    });

    document.querySelectorAll('.ab-range-card').forEach(function(card){
      addSaveButton(card.querySelector('.ab-range-card__copy'), parseJson(card.querySelector('.ab-range-sample-data')));
    });

    document.querySelectorAll('.ab-stamford-card').forEach(function(card){
      addSaveButton(card.querySelector('.ab-stamford-card__body'), itemFromSampleButton(card.querySelector('[data-stamford-sample]')));
    });

    document.querySelectorAll('.ab-find-card').forEach(function(card){
      addSaveButton(card.querySelector('.ab-find-card__actions'), itemFromSampleButton(card.querySelector('.ab-find-card__sample')));
    });

    document.querySelectorAll('.ab-search-card').forEach(function(card){
      addSaveButton(card.querySelector('.ab-search-card__copy'), parseJson(card.querySelector('.ab-search-sample-data')));
    });

    refresh();
  }

  function eligiblePaletteLink(link){
    if (!link) return false;
    var href = link.getAttribute('href') || '';
    if (!href || href.charAt(0) === '#' || /^(mailto:|tel:|javascript:)/i.test(href)) return false;
    try {
      var url = new URL(href, window.location.origin);
      if (url.origin !== window.location.origin) return false;
      return /^(\/products\/|\/collections\/|\/pages\/find-a-tile|\/search)/.test(url.pathname);
    } catch (e) { return false; }
  }

  function decoratePaletteLinks(){
    if (!modeActive()) return;
    var root = document.querySelector('main, #MainContent');
    if (!root) return;
    root.querySelectorAll('a[href]').forEach(function(link){
      if (!eligiblePaletteLink(link) || link.dataset.abPaletteLinked === '1') return;
      var original = link.getAttribute('href');
      try {
        var url = new URL(original, window.location.origin);
        if (url.pathname === '/collections/all') url.pathname = '/pages/find-a-tile';
        url.searchParams.set('palette','1');
        link.dataset.abPaletteOriginalHref = original;
        link.dataset.abPaletteLinked = '1';
        link.setAttribute('href', url.pathname + (url.search ? url.search : '') + (url.hash ? url.hash : ''));
      } catch (e) {}
    });
  }

  function restorePaletteLinks(){
    document.querySelectorAll('[data-ab-palette-linked="1"]').forEach(function(link){
      if (link.dataset.abPaletteOriginalHref) link.setAttribute('href', link.dataset.abPaletteOriginalHref);
      delete link.dataset.abPaletteLinked;
      delete link.dataset.abPaletteOriginalHref;
    });
  }

  function removeContextBar(){
    document.querySelectorAll('.ab-palette-context').forEach(function(node){ node.remove(); });
  }

  function exitPaletteMode(){
    try {
      var url = new URL(window.location.href);
      url.searchParams.delete('palette');
      window.history.replaceState({}, '', url.pathname + (url.search ? url.search : '') + (url.hash ? url.hash : ''));
    } catch (e) {}
    removeSaveButtons();
    restorePaletteLinks();
    removeContextBar();
    refresh();
  }

  function ensureContextBar(){
    if (!modeActive()) {
      removeContextBar();
      return;
    }
    if (window.location.pathname === '/pages/for-professionals' || window.location.pathname === '/pages/project-palette') {
      removeContextBar();
      return;
    }
    var existing = document.querySelector('.ab-palette-context');
    if (existing) {
      refreshContext(read());
      return;
    }
    var host = document.querySelector('main, #MainContent');
    if (!host) return;
    var bar = document.createElement('aside');
    bar.className = 'ab-palette-context';
    bar.setAttribute('aria-label','Project Palette mode');
    bar.innerHTML = '<div class="ab-palette-context__copy"><strong>Building a Project Palette</strong><span>Add tiles as you browse · <b data-ab-palette-context-count>0</b> saved</span></div><div class="ab-palette-context__actions"><a href="/pages/project-palette?palette=1#project-palette">View palette</a><button type="button" data-ab-palette-exit>Exit palette mode</button></div>';
    if (host.firstChild) host.insertBefore(bar, host.firstChild); else host.appendChild(bar);
    var exitButton = bar.querySelector('[data-ab-palette-exit]');
    if (exitButton) exitButton.addEventListener('click', exitPaletteMode);
    refreshContext(read());
  }

  function rerouteProjectLinks(){
    document.querySelectorAll('a[href="/pages/contact"],a[href^="/pages/contact?"]').forEach(function(link){
      var label = (link.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
      if (/discuss\s+(a\s+|your\s+)?project/.test(label) || /project\s+enquir/.test(label)) {
        link.setAttribute('href', '/pages/for-professionals#project-enquiry');
      }
    });
  }

  function rerouteFindATile(){
    document.querySelectorAll('a[href="/collections/all"],a[href^="/collections/all?"]').forEach(function(link){
      var label = (link.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
      if (label === 'find a tile' || label === 'browse tiles') link.setAttribute('href', '/pages/find-a-tile');
    });
    if (window.location.pathname === '/collections/all') {
      window.location.replace('/pages/find-a-tile' + window.location.search + window.location.hash);
    }
  }

  function inject(){
    rerouteProjectLinks();
    rerouteFindATile();
    if (modeActive()) {
      injectSaveButtons();
      decoratePaletteLinks();
      ensureContextBar();
    } else {
      removeSaveButtons();
      restorePaletteLinks();
      removeContextBar();
    }
    refresh();
  }

  window.AppletonBrooksProjectPalette = {
    key: KEY,
    read: read,
    write: write,
    add: add,
    remove: remove,
    toggle: toggle,
    contains: function(item){ return contains(read(), item); },
    refresh: refresh,
    inject: inject,
    modeActive: modeActive,
    exitMode: exitPaletteMode
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', inject);
  else inject();

  document.addEventListener('shopify:section:load', inject);

  var scheduled = false;
  var observer = new MutationObserver(function(){
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(function(){
      scheduled = false;
      inject();
    });
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();